import React from "react";
import { Link } from "react-router-dom";
import "../../styles/publicFooter.css";

export default function PublicFooter({ onOpenGuide }) {
  return (
    <footer className="public-footer">
      <div className="public-footer__inner">
        <div className="public-footer__brand">
          <Link to="/" className="public-footer__logo" aria-label="Veya home">
            veya
          </Link>

          <p>
            Intentional fashion discovery for boutiques and considered
            shoppers.
          </p>

          <p className="public-footer__disclaimer">
            Try-on is for visualisation only. Real fit will vary.
          </p>
        </div>

        <nav className="public-footer__links" aria-label="Footer navigation">
          <div>
            <h2>Veya</h2>
            <Link to="/">Home</Link>
            <Link to="/browse">Browse</Link>
            <Link to="/edits">Veya Edits</Link>
            <Link to="/about">About</Link>
            
            <button
              type="button"
              className="public-footer__link-button"
              onClick={onOpenGuide}
            >
              How Veya Works
            </button>
          </div>

          <div>
            <h2>Boutiques</h2>
            <Link to="/merchant/apply">Apply to Partner</Link>
            <Link to="/merchant/login">Merchant Login</Link>
            <Link to="/legal/merchant-terms">Merchant Terms</Link>
          </div>

          <div>
            <h2>Legal</h2>
            <Link to="/legal">Legal Centre</Link>
            <Link to="/legal/privacy">Privacy Policy</Link>
            <Link to="/legal/terms">Terms of Use</Link>
            <Link to="/legal/cookies">Cookies & Analytics</Link>
            <Link to="/legal/licenses">Licence Notices</Link>
          </div>

          <div>
            <h2>Contact</h2>
            <a href="mailto:hello@veya.co.nz">hello@veya.co.nz</a>
          </div>
        </nav>
      </div>

      <div className="public-footer__bottom">
        <span>© {new Date().getFullYear()} Veya. All rights reserved.</span>
      </div>
    </footer>
  );
}